import React, { createContext, useContext } from 'react'
import { useClinic } from '~contexts/clinic-context'
import { ClinicFieldsFragment } from '~graphql/generated/graphql'
import { useStateWithDebounce } from '~utils/hooks/use-state-with-debounce'

export default function ChatClinicsProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const { clinic, clinicGroup } = useClinic()

    const [filteredClinics, setFilteredClinics] = useStateWithDebounce<
        ClinicFieldsFragment[]
    >([])

    const clinics =
        filteredClinics.length > 0
            ? filteredClinics
            : clinic
              ? [clinic]
              : ((clinicGroup?.clinic_group_clinics.map(c => c.clinic) ||
                    []) as ClinicFieldsFragment[])

    return (
        <ClinicsContext.Provider
            value={{ clinics, filteredClinics, setFilteredClinics }}
        >
            {children}
        </ClinicsContext.Provider>
    )
}

type ClinicsContextType = {
    clinics: ClinicFieldsFragment[]
    filteredClinics: ClinicFieldsFragment[]
    setFilteredClinics: (clinics: ClinicFieldsFragment[]) => void
}

const ClinicsContext = createContext<ClinicsContextType>(
    {} as ClinicsContextType,
)

export function useChatClinics() {
    return useContext(ClinicsContext)
}
